import { render, staticRenderFns } from "./VCloudDirectoryItem.vue?vue&type=template&id=8c9d2082&functional=true&"
var script = {}
import style0 from "./VCloudDirectoryItem.vue?vue&type=style&index=0&id=8c9d2082&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports